// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"d18cbfd7","233":"f729c046","369":"643fd0e2","777":"d85915b3","936":"bf4f69f7"}[chunkId] + ".js";
};